export interface IDistractsPerPeriod {
  series: {name: string; data: number[]}[]
  categories: string[]
}

export interface IsalesByFranchises {
  id: number
  name: string
  total_sold: number
  total_price: string
}
interface IsalesByProductCategory {
  id: number
  name: string
  total_price: string
}

export interface IsalesPerPeriod {
  series: {name: string; data: number[]}[]
  categories: string[]
}

interface ItopProducts {
  product_name: string
  category_name: string
  category_id: number
  total_sold: number
  total_price: number
}

interface IPaserDistractsPerPeriodReturn {
  itens: IDistractsPerPeriod
  total: number
}

const parseDistractsPerPeriodData = (
  distractsPerPeriods: IDistractsPerPeriod
): IPaserDistractsPerPeriodReturn => {
  if (!distractsPerPeriods) return {total: 0, itens: {series: [], categories: []}}

  const total = distractsPerPeriods.series.reduce((sum, serie) => {
    return sum + serie.data.reduce((acc, value) => acc + value, 0)
  }, 0)

  return {total, itens: distractsPerPeriods}
}

interface IPaserSalesByFranchisesReturn {
  itens: IsalesByFranchises[]
  total: number
}

const parseSalesByFranchisesData = (
  salesByFranchises: IsalesByFranchises[]
): IPaserSalesByFranchisesReturn => {
  if (!salesByFranchises) return {total: 0, itens: []}

  const total = salesByFranchises.reduce(
    (total, item) => total + parseFloat(item.total_price || '0'),
    0
  )

  return {total, itens: salesByFranchises}
}

interface IPaserSalesByProductCategoryReturn {
  itens: IsalesByProductCategory[]
  total: number
}

const parseSalesByProductCategoryData = (
  salesByProductCategorys: IsalesByProductCategory[]
): IPaserSalesByProductCategoryReturn => {
  if (!salesByProductCategorys) return {itens: [], total: 0}

  const totalPriceSales = salesByProductCategorys.reduce(
    (total, sale) => total + parseFloat(sale.total_price || '0'),
    0
  )

  return {itens: salesByProductCategorys, total: totalPriceSales}
}

interface IPaserSalesPerPeriodReturn {
  itens: IsalesPerPeriod
  total: number
}

const parseSalesPerPeriodData = (salesPerPeriod: IsalesPerPeriod): IPaserSalesPerPeriodReturn => {
  if (!salesPerPeriod) return {total: 0, itens: {series: [], categories: []}}

  const total = salesPerPeriod.series.reduce((sum, serie) => {
    return sum + serie.data.reduce((acc, value) => acc + value, 0)
  }, 0)

  return {total, itens: salesPerPeriod}
}

interface IPaserTopProductsReturn {
  itens: ItopProducts[]
  total: number
}

const parseTopProductsData = (saleItems: ItopProducts[]): IPaserTopProductsReturn => {
  if (!saleItems) return {total: 0, itens: []}

  const total = saleItems.reduce((total, item) => total + (item.total_sold || 0), 0)

  return {total, itens: saleItems}
}

export interface IParsedDashboard {
  clientRegistrations: string
  distractsPerPeriod: IPaserDistractsPerPeriodReturn
  salesByFilteredDate: string
  salesByFranchises: IPaserSalesByFranchisesReturn
  salesByProductCategory: IPaserSalesByProductCategoryReturn
  salesPerPeriod: IPaserSalesPerPeriodReturn
  topProducts: IPaserTopProductsReturn
}

export const parseDashboard = (data): IParsedDashboard => {
  return {
    clientRegistrations: data?.clientRegistrations,
    distractsPerPeriod: parseDistractsPerPeriodData(data?.distractsPerPeriod),
    salesByFilteredDate: data?.salesByFilteredDate,
    salesByFranchises: parseSalesByFranchisesData(data?.salesByFranchises),
    salesByProductCategory: parseSalesByProductCategoryData(data?.salesByProductCategory),
    salesPerPeriod: parseSalesPerPeriodData(data?.salesPerPeriod),
    topProducts: parseTopProductsData(data?.topProducts),
  }
}
